import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  showShiftListingFilterModal,
  updateShiftListingFilters,
  updateRightShiftScheduleFilter,
} from "@/reducers/clientdashboard";
import { getIsFilterApplied } from "@/utilities/utils";

import ShiftListingFilterModal from "./ShiftListingFilterModal";
import TableSearch from "../../dataTables/TableSearch";
import FilterButton from "../../ListingFilters/FilterButton";

/**
 * A functional component for rendering the top section of the shift listing.
 *
 * @return {JSX.Element} The top section of the shift listing UI.
 */
export const ShiftListingTop = () => {
  const dispatch = useDispatch();
  const {
    rightSideShiftScheduleFilter,
    shiftListingLoading,
    shiftListingFilters,
  } = useSelector((state) => state.clientDashboard);
  const filterApplied = getIsFilterApplied(shiftListingFilters);
  const shiftPeriod = [
    {
      text: "Today",
      value: "today",
    },
    {
      text: "Week",
      value: "week",
    },
    {
      text: "Month",
      value: "month",
    },
  ];
  const [activeShiftPeriod, setActiveShiftPeriod] = useState("month");
  useEffect(() => {
    dispatch(
      updateRightShiftScheduleFilter({
        shift_type: activeShiftPeriod,
      }),
    );
  }, [activeShiftPeriod]);
  useEffect(() => {
    if (rightSideShiftScheduleFilter.shift_type) {
      if (rightSideShiftScheduleFilter.shift_type !== "month") {
        // reseting shift listing filters on tab change if not month
        dispatch(updateShiftListingFilters({}));
      }
      setActiveShiftPeriod(rightSideShiftScheduleFilter.shift_type);
    } else {
      setActiveShiftPeriod("");
    }
  }, [rightSideShiftScheduleFilter.shift_type]);
  /**
   * Function to handle the search input and update the shift schedule filter.
   *
   * @param {Event} e - the event object
   * @return {void}
   */
  const handleSearch = (e) => {
    dispatch(updateRightShiftScheduleFilter({ search: e.target.value }));
  };
  return (
    <div className="ShiftListingTop_Wrapper">
      <div className="flex justify-between gap-2 max-md:flex-col">
        <div className="flex gap-[12px]">
          {rightSideShiftScheduleFilter.shift_date ? (
            <div
              className={`${shiftListingLoading ? "pointer-events-none" : ""} shiftperiod_item flex h-[40px] w-[105px] cursor-pointer select-none items-center justify-center rounded-lg bg-lightblue text-base font-medium leading-[24px] text-primary transition-all duration-200 ease-linear`}
            >
              {moment(
                rightSideShiftScheduleFilter.shift_date,
                "YYYY-MM-DD",
              ).format("DD/MM/YYYY")}
            </div>
          ) : null}
          {shiftPeriod.map((item, index) => (
            <div
              key={index}
              className={`${shiftListingLoading ? "pointer-events-none" : ""} shiftperiod_item flex h-[40px] w-[105px] cursor-pointer select-none items-center justify-center rounded-lg text-base font-medium leading-[24px] transition-all duration-200 ease-linear ${
                activeShiftPeriod === item.value &&
                rightSideShiftScheduleFilter.shift_date == ""
                  ? "bg-lightblue text-primary"
                  : "bg-grey text-txtColor"
              }`}
              onClick={() => {
                dispatch(
                  updateRightShiftScheduleFilter({
                    shift_date: "",
                    shift_type: item.value,
                  }),
                );
                setActiveShiftPeriod(item.value);
              }}
            >
              {item.text}
            </div>
          ))}
        </div>
        <div className="flex grow justify-end gap-[20px]">
          <TableSearch
            val={rightSideShiftScheduleFilter.search}
            handleChange={handleSearch}
          />
          {/* displaying filters if month type is selected in shift listing tabs */}
          {rightSideShiftScheduleFilter.shift_type === "month" ? (
            <>
              <FilterButton
                filterApplied={filterApplied}
                handleClick={() => {
                  dispatch(showShiftListingFilterModal(true));
                }}
              />
            </>
          ) : null}
          <ShiftListingFilterModal />
        </div>
      </div>
    </div>
  );
};
